/**
 * Created by eliasmj on 21/09/2015.
 */
angular.module('qkr.mssConfig')
    .controller('MssConfigMessagesController', function(mssConfigService) {
        const self = this;

        self.messages = mssConfigService.getCurrentMessages();
});



// WEBPACK FOOTER //
// ./src/mssConfig/controllers/mssConfigMessagesController.js